import { LayoutFurnitureT } from './layout/furniture';
import { Product } from './product';

export type ProductList = Product[];

export const includesSku = (sku: string, ps: ProductList) =>
    ps.some(product => product.sku === sku);

export const includesLayoutFurniture = (ps: ProductList) => (layoutFurniture: LayoutFurnitureT) =>
    layoutFurniture.products.some(p => includesSku(p.productId, ps));
